import { watchEntities, findEntities, getEntity, updateEntity, deleteEntity, createEntity, unwatchEntities } from './EntitiesSagas';
import { HallsActions } from '../reducers/HallsRedux'

export function* watchHalls(api) {
  yield watchEntities(api, 'hall', HallsActions)
}

export function* unwatchHalls(api){
  yield unwatchEntities(api, 'hall', HallsActions)
}

export function* findHalls(api, action) {
  yield findEntities(api, 'hall', HallsActions, action)
}

export function* getHall(api, action) {
  yield getEntity(api, HallsActions, action)
}

export function* updateHall(api, action) {
  yield updateEntity(api, HallsActions, action)
}

export function* deleteHall(api, action) {
  yield deleteEntity(api, HallsActions, action)
}

export function* createHall(api, action) {
  yield createEntity(api, HallsActions, action)
}
